import { Link } from 'react-router-dom';

export default function Footer({ settings = {} }) {
  return (
    <footer className="bg-gray-900 text-gray-300 py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center text-2xl font-bold text-white mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="16 18 22 12 16 6" />
                <polyline points="8 6 2 12 8 18" />
              </svg>
              Retic
            </Link>
            <p className="text-gray-400 mb-4 text-sm">
              {settings.footer_tagline || 'We build revenue engines, not just apps.'}
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/case-studies" className="hover:text-white transition">Case Studies</Link></li>
              <li><Link to="/blog" className="hover:text-white transition">Blog</Link></li>
              <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
              <li><Link to="/growth-audit" className="hover:text-white transition">Growth Audit</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li>Web App Development</li>
              <li>Progressive Web Apps</li>
              <li>UX/UI Design</li>
              <li>Custom Solutions</li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>{settings.contact_phone || '+1 (360) 306-2409'}</li>
              <li>{settings.contact_email || 'info@retic.media'}</li>
              <li>{settings.contact_address || 'Queen Creek, AZ'}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-sm text-gray-500">
          &copy; {new Date().getFullYear()} Retic Media. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
